import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Button } from "../Shared/FormElements/Button";
import { Input } from "../Shared/FormElements/Input";
import { DynamicTag } from "../Shared/TagInput";
import "./topics.sass";
import SocialConnect from "../SocialConnect";
import { getUniqueValuesFromList } from "../../utility/common-methods";
import CustomAccordian from "../Shared/CustomAccordian";
import { fetchSocialEntityDetails } from "../../actions/entity-action";
import { unifiedEnvConfig } from "../../constants/api-endpoint";
import { httpPost, httpPut, httpGet } from "../../utility/requestHelper";
import { HTTP_CODES } from "../../constants/app-constant";

const [fill, connect] = [1, 2];

export const AddTopic = ({ data, setShowAddTopic, setEditData, isEdit }) => {
  const dispatch = useDispatch();
  const selectedClient =
    useSelector(
      (state) => state.clientReducer && state.clientReducer.selectedClient
    ) || {};
  const [topicname, setTopicname] = useState("");
  const [orKeywords, setorKeywords] = useState([]);
  const [andKeywords, setandKeywords] = useState([]);
  const [notcontainsKeywords, setnotKeywords] = useState([]);
  const [hashtagKeywords, setHashtagKeywords] = useState([]);
  const [category, setCategory] = useState("client");
  const [addTopicStep, setAddTopicStep] = useState(fill);
  const [addTopicError, setAddTopicError] = useState("");
  const [showAuth, setShowAuth] = useState(false);
  const [pageIds, setPageIds] = useState([]);
  const [showHT, setShowHT] = useState(false);
  const [isTopicAdditionIsProgress, setIsTopicAdditionInProgress] =
    useState(false);
  const [hashTagsLimit, setHashTagsLimit] = useState(false);
  const id = data && data.id ? data.id : "";
  useEffect(() => {
    return () => {
      setEditData(null);
    };
  }, []);

  useEffect(() => {
    if (data) {
      const {
        name,
        and_contains,
        or_contains,
        not_contains,
        hashtags,
        category,
        page_ids,
      } = data;
      setTopicname(name || "");
      setCategory(category || "client");
      setHashtagKeywords(hashtags || []);
      setorKeywords(or_contains || []);
      setandKeywords(and_contains || []);
      setnotKeywords(not_contains || []);
      setPageIds(page_ids || []);
    }
  }, [data]);

  useEffect(() => {
    httpGet(
      `${unifiedEnvConfig.HASHTAGS}/${id}?client_id=${selectedClient.id}`
    ).then((response) => {
      const { data } = response.data;
      const { remaining_hashtags } = data;
      setHashTagsLimit(hashtagKeywords.length > remaining_hashtags);
    });
  }, [hashtagKeywords]);

  useEffect(() => {
    setAddTopicError("");
  }, [orKeywords, andKeywords, notcontainsKeywords]);

  const cancelForm = () => {
    setShowAddTopic(false);
    setEditData(undefined);
  };

  const removeSpace = (data) => {
    return data.filter(function (entry) {
      return /\S/.test(entry);
    });
  };

  const removeSpecialCharacters = (data) => {
    return data.map(function (entry) {
      return entry.replace(/[^a-zA-Z ]/g, "").toLowerCase();
    });
  };

  const addTopic = (evt) => {
    try {
      if (!topicname) {
        return;
      }
      setIsTopicAdditionInProgress(true);
      evt.preventDefault();
      const editKey = data ? true : false;
      let or_contains = removeSpace(orKeywords);
      let and_contains = removeSpace(andKeywords);
      let not_contains = removeSpace(notcontainsKeywords);
      const aggregatedKW = [...or_contains, ...and_contains, ...not_contains];
      const uniqueAggregatedKW = getUniqueValuesFromList(
        aggregatedKW,
        null,
        false
      );
      if (uniqueAggregatedKW.length !== aggregatedKW.length) {
        setAddTopicError("Keyword should be unique in all the fields");
        return;
      }
      if (!or_contains.length) {
        setAddTopicError("Please enter OR contains keyword");
        return;
      }
      let hashtags = [...new Set(removeSpecialCharacters(hashtagKeywords))];
      let topicData = {
        topic_name: topicname,
        and_contains: and_contains,
        or_contains: or_contains,
        not_contains: not_contains,
        type: 1,
        page_ids: pageIds,
        hashtags: hashtags,
        category: category,
      };

      if (isEdit) {
        httpPut(
          `${unifiedEnvConfig.ADD_TOPIC}/${id}?client_id=${selectedClient.id}`,
          { ...topicData, id }
        )
          .then(({ status }) => {
            if (status === HTTP_CODES.SUCCESS) {
              setShowAddTopic(false);
              setEditData(false);
              dispatch(fetchSocialEntityDetails(selectedClient.id));
            } else {
              setAddTopicError("Error editing topic");
            }
          })
          .catch((e) => {
            console.log("Error editing topic", e);
            setAddTopicError("Error editing topic");
          })
          .finally(() => {
            setIsTopicAdditionInProgress(false);
          });
      } else {
        httpPost(
          `${unifiedEnvConfig.ADD_TOPIC}?client_id=${selectedClient.id}`,
          topicData
        )
          .then(({ status }) => {
            if (status === HTTP_CODES.CREATED) {
              setShowAddTopic(false);
              dispatch(fetchSocialEntityDetails(selectedClient.id));
            } else {
              setAddTopicError("Error adding topic");
            }
          })
          .catch((e) => {
            console.log("Error adding topic", e);
            setAddTopicError("Error adding topic");
          })
          .finally(() => setEditData(null));
      }
    } catch (e) {
      return;
    }
  };
  const activeClass = showAuth ? "show" : "";
  return (
    <React.Fragment>
      <div className="addTopicWrap">
        <div className="topicFormWrapp">
          <div className="topicSection">
            <h3>Topic Title</h3>
            <div className="form-group">
              <Input
                id="topicname"
                className="form-control"
                placeholder="Type here..."
                value={topicname}
                onChange={setTopicname}
                required
              />
            </div>
          </div>
          <div className="topicSection">
            <h3 className="tagTitle">Keywords</h3>
            <div className="form-group">
              <label>
                <strong>“Contains”</strong> at least one of the keyword below
              </label>
              <DynamicTag
                key={orKeywords}
                data={orKeywords}
                setKeywords={setorKeywords}
              />
            </div>
            <div className="form-group">
              <label>
                <strong>“And Contains”</strong> all of the keywords below
              </label>
              <DynamicTag
                key={andKeywords}
                data={andKeywords}
                setKeywords={setandKeywords}
              />
            </div>
            <div className="form-group">
              <label>
                <strong>“Does Not Contain”</strong> any of the keywords below
              </label>
              <DynamicTag
                key={notcontainsKeywords}
                data={notcontainsKeywords}
                setKeywords={setnotKeywords}
              />
            </div>

            <h3>Select Tag</h3>
            <div className="form-group">
              <div className="radioGroup">
                <div className="radioBtn">
                  <label className="inputWrap">
                    Client
                    <input
                      type="radio"
                      name="client"
                      value="client"
                      checked={category === "client"}
                      onChange={() => setCategory("client")}
                    />
                    <span className="checkmark"></span>
                  </label>
                </div>
                <div className="radioBtn">
                  <label className="inputWrap">
                    Industry
                    <input
                      type="radio"
                      name="industry"
                      value="industry"
                      checked={category === "industry"}
                      onChange={() => setCategory("industry")}
                    />
                    <span className="checkmark"></span>
                  </label>
                </div>
                <div className="radioBtn">
                  <label className="inputWrap">
                    Competitors
                    <input
                      type="radio"
                      name="competitor"
                      value="competitor"
                      checked={category === "competitor"}
                      onChange={() => setCategory("competitor")}
                    />
                    <span className="checkmark"></span>
                  </label>
                </div>
              </div>
            </div>
          </div>
          <CustomAccordian
            onCardClick={() => setShowHT(!showHT)}
            activeClass={showHT ? "show" : ""}
            headerText="Instagram Hashtags"
            children={
              <>
                <div className="form-group">
                  <label>
                    Add <strong>"#" Hashtags</strong> to fetch results from
                    instagram.
                    {/* <strong>“Contains”</strong> any of the #Tags below */}
                  </label>
                  <DynamicTag
                    key={hashtagKeywords}
                    data={hashtagKeywords}
                    setKeywords={setHashtagKeywords}
                    placeholder="# Type here..."
                  />
                  <label>
                    {!hashTagsLimit
                      ? "You need to authorize your account to see the results."
                      : "You have exceeded hashtag limit"}
                    {/* TODO need to change message once we get confirmation */}
                    {/* using Instagram Hashtags. */}
                  </label>
                </div>
              </>
            }
          />
          <CustomAccordian
            onCardClick={() => setShowAuth(!showAuth)}
            activeClass={activeClass}
            headerText="Authorize Account"
            children={
              <SocialConnect
                setEditData={setEditData}
                setAddTopicStep={setAddTopicStep}
                pageIds={pageIds}
                setPageIds={setPageIds}
              />
            }
          />
          <div className="btn-container">
            <Button
              label="Cancel"
              className="btn btnBlue "
              onClick={cancelForm}
              type="button"
            />
            <Button
              label={
                isTopicAdditionIsProgress
                  ? "Please wait..."
                  : isEdit
                  ? "Save Changes"
                  : "Add Topic"
              }
              className="btn btnBlue"
              onClick={addTopic}
              type="submit"
              disabled={
                addTopicError || isTopicAdditionIsProgress || hashTagsLimit
              }
            />
          </div>
          <div>
            <span className="text-danger">{addTopicError || ""}</span>
          </div>
          {"   "}
        </div>
      </div>
    </React.Fragment>
  );
};

export default AddTopic;

AddTopic.defaultProps = {
  setEditData: () => {},
  data: [],
  setShowAddTopic: () => {},
  isEdit: false,
};
